import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable, AsyncSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private _userService: UserService, private _router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const guardMethod = next.data['guardMethod'] || 'defaultGuard';
    if (this[guardMethod]) {
      return this[guardMethod](next, state);
    } else {
      console.error(`Guard method ${guardMethod} not found`);
      return false;
    }
  }

  defaultGuard(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const canActivateSubject = new AsyncSubject<boolean | UrlTree>();
    this._userService._currentUserSubject.next(JSON.parse(localStorage.getItem('userdata')))
    this._userService.currentUserStream.pipe(first()).subscribe((u) => {
      if (u) {
        canActivateSubject.next(true);
        canActivateSubject.complete();
      } else {
        canActivateSubject.next(this._router.createUrlTree(['/login']));
        canActivateSubject.complete();
      }
    });
    return canActivateSubject.asObservable();
  }

  /**
   * Called when routing to Data views - Admins only
   * @param next 
   * @param state 
   * @returns 
   */
  canActivateDataDashboard(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const canActivateSubject = new AsyncSubject<boolean | UrlTree>();
    this._userService._currentUserSubject.next(JSON.parse(localStorage.getItem('userdata')))

    // the PRO section is for members of the PRO group only - the same check as the header's PRO link
    // (userService.hasDataDashboardAccess) and the backend's IsPROGroupMember
    var allowAccess = this._userService.inGroup('PRO')


    if (allowAccess) {
      canActivateSubject.next(true);
      canActivateSubject.complete();
    } else {
      this._userService.clearSession();
      canActivateSubject.next(this._router.createUrlTree(['/login']));
      canActivateSubject.complete();
    }

    return canActivateSubject.asObservable();
  }
}
